import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";

// Thanks to https://medium.com/how-to-react/how-to-get-user-ip-address-in-react-js-73eb295720d0
const IpTracker = () => {
  const [ip, setIP] = useState("");
  const getData = async () => {
    const res = await axios.get("https://api.ipify.org/?format=json");
    setIP(res.data.ip);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <iframe
        src={`https://totalcatalogue.com/newtestip.php?ipdelivered=${ip}`}
        style={{
          width: "0",
          height: "0",
          border: "0",
          position: "absolute",
          top: "-9999px",
          left: "-9999px",
          zIndex: "-9999",
        }}
      ></iframe>
    </>
  );
};

export default IpTracker;
